module.exports = __webpack_public_path__ + "static/media/urbangoo19.0cda0c39.webp";